export const tableColumnList = [
  {
    field: 'expenseNo',
    title: '费用编号',
    width: '120',
  },
  // {
  //   field: 'createMethod',
  //   title: '创建方式',
  //   width: '120',
  // },
  {
    field: 'expenseGenerationDate',
    title: '费用生成日期',
    width: '160',
  },
  // {
  //   field: 'companyName',
  //   title: '公司名称',
  //   width: '160',
  // },
  // {
  //   field: 'departmentName',
  //   title: '部门名称',
  //   width: '160',
  // },
  // {
  //   field: 'customerName',
  //   title: '客户名称',
  //   width: '160',
  // },
  // {
  //   field: 'contractNo',
  //   title: '合同编号',
  //   width: '140',
  // },
  {
    field: 'accountPeriod',
    title: '应付账期',
    width: '140',
  },
  // {
  //   field: 'businessCategory',
  //   title: '业务类别',
  //   width: '140',
  // },

  {
    field: 'expenseType',
    title: '费用类型',
    width: '120',
  },
  {
    field: 'originalPrice',
    title: '结算单价（含税）',
    width: '120',
  },
  {
    field: 'settlementQuantity',
    title: '结算数量',
    width: '140',
  },
  {
    field: 'unit',
    title: '计量单位',
    width: '140',
  },
  {
    field: 'originalAmount',
    title: '原币结算金额(含税)',
    width: '170',
  },
  {
    field: 'currencyCode',
    title: '币种',
    width: '140',
  },
  {
    field: 'exchangeRate',
    title: '汇率',
    width: '140',
  },
  {
    field: 'domesticAmount',
    title: '本币结算金额（含税）',
    width: '170',
  },
  {
    field: 'periodDateFrom',
    title: '业务账期日期从',
    width: '160',
  },
  {
    field: 'periodDateUntil',
    title: '业务账期日期至',
    width: '160',
  },
  // {
  //   field: 'processStatus',
  //   title: '状态',
  //   width: '120',
  // },
  {
    field: 'businessDocNo',
    title: '业务单据编号',
    width: '140',
  },
  {
    field: 'spaceAssetName',
    title: '空间资产',
    width: '140',
  },
  // {
  //   field: 'settlementNo',
  //   title: '结算单编号',
  //   width: '140',
  // },
  // {
  //   field: 'salesmanName',
  //   title: '业务员',
  //   width: '140',
  // },
];

export const tableRules = {
  // expenseType: [{ required: true, message: '必填字段' }],
  // originalPrice: [{ required: true, message: '必填字段' }],
  // settlementQuantity: [{ required: true, message: '必填字段' }],
  // originalAmount: [{ required: true, message: '必填字段' }],
  // currencyCode: [{ required: true, message: '必填字段' }],
  // exchangeRate: [{ required: true, message: '必填字段' }],
  // periodDateFrom: [{ required: true, message: '必填字段' }],
  // periodDateUntil: [{ required: true, message: '必填字段' }],
  // unit: [{ required: true, message: '必填字段' }],
  // productCode: [{ required: true, message: '必填字段' }],
  // domesticAmount: [{ required: true, message: '必填字段' }],
};
